(() => {
  const money = new Intl.NumberFormat('en-SA', { style: 'currency', currency: 'SAR', maximumFractionDigits: 0 });
  const dateFormatter = new Intl.DateTimeFormat('en-GB', { day: 'numeric', month: 'long', year: 'numeric' });
  const monthFormatter = new Intl.DateTimeFormat('en-GB', { month: 'long', year: 'numeric' });
  const value = (input) => Number.parseFloat(input?.dataset.addonPrice || '0') || 0;

  const updateTotal = (card) => {
    const base = Number.parseFloat(card.dataset.privateEventsBasePrice?.replace(/[^0-9.]/g, '') || '0') || 0;
    const extras = [...card.querySelectorAll('[data-private-events-addon]:checked')].reduce((sum, input) => sum + value(input), 0);
    const target = card.querySelector('[data-private-events-total]');
    if (target) target.textContent = money.format(base + extras);
  };

  const feedback = (card, message = '') => {
    const target = card.querySelector('[data-private-events-feedback]');
    if (target) target.textContent = message;
  };

  const asProperty = (card, label) => card.querySelector(`[name="properties[${label}]"]`);
  const isoDate = (date) => [date.getFullYear(), String(date.getMonth() + 1).padStart(2, '0'), String(date.getDate()).padStart(2, '0')].join('-');
  const parseIsoDate = (value) => value ? new Date(`${value}T12:00:00`) : null;
  const today = () => { const now = new Date(); return new Date(now.getFullYear(), now.getMonth(), now.getDate()); };

  const closePopovers = (root, except = null) => {
    root.querySelectorAll('[data-private-events-calendar], [data-private-events-time-menu]').forEach((popover) => {
      if (popover !== except) popover.hidden = true;
    });
    root.querySelectorAll('[data-private-events-date-trigger], [data-private-events-time-trigger]').forEach((trigger) => {
      if (trigger !== except?.previousElementSibling) trigger.setAttribute('aria-expanded', 'false');
    });
  };

  const getSlots = (slot) => {
    const raw = (slot.dataset.privateEventsTimeSlots || '').trim();
    if (!raw) return [];
    try { return JSON.parse(raw); } catch (_) { return raw.split(',').map((item) => item.trim()).filter(Boolean); }
  };

  const prettyTime = (time) => {
    const [hours, minutes] = time.split(':').map(Number);
    const suffix = hours >= 12 ? 'PM' : 'AM';
    return `${((hours + 11) % 12) + 1}:${String(minutes).padStart(2, '0')} ${suffix}`;
  };

  const renderCalendar = (slot, viewDate) => {
    const calendar = slot.querySelector('[data-private-events-calendar]');
    const grid = slot.querySelector('[data-private-events-calendar-grid]');
    const label = slot.querySelector('[data-private-events-month-label]');
    const input = slot.querySelector('[data-private-events-date]');
    const chosen = parseIsoDate(input.value);
    const now = today();
    const first = new Date(viewDate.getFullYear(), viewDate.getMonth(), 1);
    const final = new Date(viewDate.getFullYear(), viewDate.getMonth() + 1, 0);
    label.textContent = monthFormatter.format(viewDate);
    grid.replaceChildren();
    for (let blank = 0; blank < first.getDay(); blank += 1) grid.append(document.createElement('span'));
    for (let day = 1; day <= final.getDate(); day += 1) {
      const date = new Date(viewDate.getFullYear(), viewDate.getMonth(), day);
      const button = document.createElement('button');
      button.type = 'button';
      button.textContent = String(day);
      button.dataset.privateEventsCalendarDate = isoDate(date);
      button.setAttribute('role', 'gridcell');
      button.setAttribute('aria-label', dateFormatter.format(date));
      if (date.getTime() === now.getTime()) button.dataset.today = 'true';
      if (chosen && date.getTime() === chosen.getTime()) { button.dataset.selected = 'true'; button.setAttribute('aria-selected', 'true'); }
      if (date < now) { button.disabled = true; button.setAttribute('aria-disabled', 'true'); }
      grid.append(button);
    }
    calendar.dataset.privateEventsView = isoDate(first);
  };

  const chooseDate = (slot, value) => {
    const input = slot.querySelector('[data-private-events-date]');
    input.value = value;
    input.dispatchEvent(new Event('change', { bubbles: true }));
    slot.querySelector('[data-private-events-date-value]').textContent = dateFormatter.format(parseIsoDate(value));
    const calendar = slot.querySelector('[data-private-events-calendar]');
    calendar.hidden = true;
    slot.querySelector('[data-private-events-date-trigger]').setAttribute('aria-expanded', 'false');
  };

  const renderTimes = (slot) => {
    const menu = slot.querySelector('[data-private-events-time-menu]');
    const input = slot.querySelector('[data-private-events-time]');
    const slots = getSlots(slot);
    menu.replaceChildren();
    if (!slots.length) {
      const note = document.createElement('p');
      note.className = 'honey-private-events__picker-empty';
      note.textContent = 'Available times will appear here once the booking calendar is connected.';
      menu.append(note);
      return;
    }
    slots.forEach((time) => {
      const option = document.createElement('button');
      option.type = 'button';
      option.dataset.privateEventsTimeOption = time;
      option.textContent = prettyTime(time);
      option.setAttribute('role', 'option');
      option.setAttribute('aria-selected', String(input.value === time));
      if (input.value === time) option.dataset.selected = 'true';
      menu.append(option);
    });
  };

  const initializeSlotPicker = (root, slot) => {
    const dateTrigger = slot.querySelector('[data-private-events-date-trigger]');
    const timeTrigger = slot.querySelector('[data-private-events-time-trigger]');
    const calendar = slot.querySelector('[data-private-events-calendar]');
    const timeMenu = slot.querySelector('[data-private-events-time-menu]');
    const monthDelta = (amount) => {
      const current = parseIsoDate(calendar.dataset.privateEventsView) || today();
      const next = new Date(current.getFullYear(), current.getMonth() + amount, 1);
      renderCalendar(slot, next);
    };
    renderCalendar(slot, today());
    renderTimes(slot);
    dateTrigger.addEventListener('click', () => {
      const willOpen = calendar.hidden;
      closePopovers(root, willOpen ? calendar : null);
      calendar.hidden = !willOpen;
      dateTrigger.setAttribute('aria-expanded', String(willOpen));
      if (willOpen) renderCalendar(slot, parseIsoDate(calendar.dataset.privateEventsView) || today());
    });
    timeTrigger.addEventListener('click', () => {
      const willOpen = timeMenu.hidden;
      closePopovers(root, willOpen ? timeMenu : null);
      timeMenu.hidden = !willOpen;
      timeTrigger.setAttribute('aria-expanded', String(willOpen));
      if (willOpen) renderTimes(slot);
    });
    slot.querySelector('[data-private-events-month-previous]').addEventListener('click', () => monthDelta(-1));
    slot.querySelector('[data-private-events-month-next]').addEventListener('click', () => monthDelta(1));
    calendar.addEventListener('click', (event) => {
      const date = event.target.closest('[data-private-events-calendar-date]')?.dataset.privateEventsCalendarDate;
      if (date) chooseDate(slot, date);
    });
    timeMenu.addEventListener('click', (event) => {
      const option = event.target.closest('[data-private-events-time-option]');
      if (!option) return;
      slot.querySelector('[data-private-events-time]').value = option.dataset.privateEventsTimeOption;
      slot.querySelector('[data-private-events-time-value]').textContent = prettyTime(option.dataset.privateEventsTimeOption);
      slot.querySelector('[data-private-events-time]').dispatchEvent(new Event('change', { bubbles: true }));
      timeMenu.hidden = true;
      timeTrigger.setAttribute('aria-expanded', 'false');
    });
  };

  const book = async (root, card, button) => {
    feedback(card);
    if (root.dataset.bookingReady !== 'true') {
      feedback(card, 'Booking calendar setup is required before checkout can be enabled.');
      return;
    }
    const date = card.querySelector('[data-private-events-date]');
    const time = card.querySelector('[data-private-events-time]');
    const terms = card.querySelector('[data-private-events-terms]');
    const variantId = card.dataset.privateEventsVariantId;
    if (!variantId || !date?.value || !time?.value || !terms?.checked) {
      feedback(card, 'Choose an available date and time, then accept the terms to continue.');
      return;
    }
    const addOns = [...card.querySelectorAll('[data-private-events-addon]:checked')];
    const labels = addOns.map((input) => input.dataset.addonLabel).filter(Boolean).join(', ') || 'None';
    const packageName = card.dataset.privateEventsPackage || '';
    asProperty(card, 'Private Event Package').value = packageName;
    asProperty(card, 'Event Date').value = date.value;
    asProperty(card, 'Event Time').value = time.value;
    asProperty(card, 'Add-ons').value = labels;
    asProperty(card, 'Booking acknowledgement').value = 'Terms accepted';
    const properties = { 'Private Event Package': packageName, 'Event Date': date.value, 'Event Time': time.value, 'Add-ons': labels, 'Booking acknowledgement': 'Terms accepted' };
    const items = [{ id: Number(variantId), quantity: 1, properties }];
    addOns.forEach((input) => { if (input.dataset.addonVariantId) items.push({ id: Number(input.dataset.addonVariantId), quantity: 1, properties }); });
    button.disabled = true;
    button.textContent = 'Adding to cart…';
    try {
      const response = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) });
      if (!response.ok) throw new Error(await response.text());
      window.location.assign('/cart');
    } catch (error) {
      console.error('Private Events cart error', error);
      feedback(card, 'This time is no longer available. Please choose another available date and time.');
      button.disabled = false;
      button.textContent = 'Book Event';
    }
  };

  const initialize = (root) => {
    if (!root || root.dataset.privateEventsReady === 'true') return;
    root.querySelectorAll('[data-private-events-package]').forEach((card) => {
      card.querySelectorAll('[data-private-events-addon]').forEach((input) => input.addEventListener('change', () => updateTotal(card)));
      card.querySelectorAll('[data-private-events-slot]').forEach((slot) => initializeSlotPicker(root, slot));
      card.querySelector('[data-private-events-book]')?.addEventListener('click', (event) => book(root, card, event.currentTarget));
      updateTotal(card);
    });
    root.addEventListener('click', (event) => { if (!event.target.closest('[data-private-events-slot]')) closePopovers(root); });
    root.addEventListener('keydown', (event) => { if (event.key === 'Escape') { closePopovers(root); event.target.closest('[data-private-events-slot]')?.querySelector('[aria-expanded="true"]')?.focus(); } });
    root.dataset.privateEventsReady = 'true';
  };

  const all = (scope = document) => scope.querySelectorAll('[data-private-events-section]').forEach(initialize);
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', () => all()) : all();
  document.addEventListener('shopify:section:load', (event) => all(event.target));
})();
